export const MARKINGS = ['Partially Met', 'Achieving', 'High Performing', 'Exceeding'];
export const POSITIONS = [
  '9 Inconsistent',
  '8 Effective',
  '7 Early Promise',
  '6 Expert',
  '5 Good',
  '4 Strong',
  '3 High Potential',
  '2 Excellent',
  '1 Star',
];

export default function ModerationDistribution({
  title,
  values,
  outcomes,
}: {
  title: string;
  values: string[];
  outcomes: string[];
}) {
  const rated = values.filter((value) => outcomes.includes(value));
  const segments = outcomes
    .map((label, index) => ({
      label,
      count: rated.filter((value) => value === label).length,
      colour: `hsl(${Math.round((index * 140) / (outcomes.length - 1))} 60% 28%)`,
    }))
    .filter(({ count }) => count > 0);
  return (
    <section className="scs-moderation-distribution" aria-label={title}>
      <h2 className="govuk-heading-s">{title}</h2>
      {rated.length ? (
        <>
          <div className="scs-moderation-distribution__bar">
            {segments.map(({ label, count, colour }) => {
              const percentage = (count * 100) / rated.length;
              const text = `${Number(percentage.toFixed(1))}%`;
              return (
                <div
                  key={label}
                  className="scs-moderation-distribution__segment"
                  style={{ flexBasis: `${percentage}%`, backgroundColor: colour }}
                  title={`${label}: ${text} (${count})`}
                  aria-label={`${label}: ${text} (${count})`}
                >
                  <span
                    aria-hidden="true"
                    style={percentage < 6 ? { writingMode: 'vertical-rl' } : undefined}
                  >
                    {text}
                  </span>
                </div>
              );
            })}
          </div>
          <ul className="scs-moderation-distribution__legend govuk-list">
            {segments.map(({ label, count, colour }) => (
              <li key={label}>
                <span style={{ backgroundColor: colour }} aria-hidden="true" />
                {label} ({count})
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="govuk-body">No ratings set yet.</p>
      )}
      {values.length > rated.length && (
        <p className="govuk-hint">
          {values.length - rated.length} without a recognised rating. Percentages use rated staff
          only.
        </p>
      )}
    </section>
  );
}
